import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";

function SuperAdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@uride.in");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const submit = async (event) => {
    event.preventDefault(); setError(""); setSubmitting(true);
    try {
      const response = await api.post("/auth/login", { email, password });
      if (response.data.user.role !== "superadmin") throw new Error("This account does not have Super Admin access.");
      localStorage.setItem("uride_token", response.data.token);
      localStorage.setItem("uride_user", JSON.stringify(response.data.user));
      navigate("/superadmin");
    } catch (err) { setError(err.response?.data?.message || err.message || "Unable to sign in."); }
    finally { setSubmitting(false); }
  };
  return <main className="superadmin-login"><section><p className="superadmin-eyebrow">URIDE CONTROL CENTER</p><h1>Super Admin<br />sign in.</h1><p>Secure access to operational oversight, payments and fleet compliance.</p></section><form onSubmit={submit}><div className="superadmin-lock">✦</div><h2>Welcome back</h2><p>Use your Super Admin credentials to continue.</p>{error && <div className="superadmin-login-error">{error}</div>}<label>Email address<input type="email" value={email} onChange={(event) => setEmail(event.target.value)} required /></label><label>Password<input type="password" value={password} onChange={(event) => setPassword(event.target.value)} required /></label><button disabled={submitting}>{submitting ? "Signing in…" : "Sign in securely"}</button></form></main>;
}
export default SuperAdminLoginPage;
